import {
  AuthSessionState,
  setCurrentAuthSessionIndex,
  useAuthState,
} from "../Login/State";
import { Box, ColorType, useBoxStyle } from "arkh";
import { FlatList, View } from "react-native";
import React, { useCallback, useMemo } from "react";

import { UserItem } from "./UserItem";
import { LoginItem } from "./LoginItem";
import { useLogin } from "../Login/useLogin";

type ActiveUser = AuthSessionState;

function keyExtractor(item: ActiveUser) {
  return item.idToken;
}

type ActiveUserProps = {
  backgroundColor?: ColorType;
  onActiveUserPress?: () => void;
  hideLogin?: boolean;
  ref?: React.RefObject<View | null>;
};

export const AuthenticatedUsersHorizontalList = ({
  onActiveUserPress: openUserProfile,
  hideLogin,
  backgroundColor,
  ref,
}: ActiveUserProps) => {
  const [authState, dispatch] = useAuthState();

  const renderItem = useCallback(
    ({
      item,
      index,
    }: {
      item: ActiveUser & { realIndex: number };
      index: number;
    }) => (
      <Box spaceRight="medium" style={{ flex: 1, height: "100%" }}>
        <UserItem
          ref={index === 0 ? ref : undefined}
          selected={index === 0}
          name={item.user.name}
          onPress={
            index === 0
              ? openUserProfile
              : () => dispatch(setCurrentAuthSessionIndex(item.realIndex))
          }
        />
      </Box>
    ),
    [dispatch, openUserProfile, ref]
  );
  const activeUsers = useMemo(
    () => [
      ...(authState.currentAuthSessionIndex !== undefined
        ? [
            {
              ...authState.authSessions[authState.currentAuthSessionIndex],
              realIndex: authState.currentAuthSessionIndex,
            },
          ]
        : []),
      ...authState.authSessions
        .map((a, index) => ({ ...a, realIndex: index }))
        .filter((_, index) => index !== authState.currentAuthSessionIndex),
    ],
    [authState.authSessions, authState.currentAuthSessionIndex]
  );
  const contentContainerStyle = useBoxStyle({
    spaceLeft: "medium",
    spaceVertical: "medium",
  });

  const [login, isLoggingIn] = useLogin();
  return (
    <Box style={{ flexDirection: "row", alignItems: "center", width: "100%" }}>
      <FlatList
        showsHorizontalScrollIndicator={false}
        horizontal
        data={activeUsers}
        renderItem={renderItem}
        keyExtractor={keyExtractor}
        contentContainerStyle={contentContainerStyle}
      />
      {hideLogin ? null : (
        <LoginItem
          login={() => login()}
          isLoggingIn={isLoggingIn}
          backgroundColor={backgroundColor}
        />
      )}
    </Box>
  );
};
